import React, {useState} from "react";
import { Dashboard } from "@/components/Dashboard";
import { Modal, message, Tree, Button, Row, Col, Drawer, Space, Carousel, Avatar, Form, Input, Select, TimePicker, Switch ,Tabs} from 'antd';
import "./AnalyticsDashboard.css";
import MunicipalitySearchAnalytics from "../MunicipalitySearchAnalytics";
import StandType from "../StandType";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import CommentsWidget from "../Widgets/CommentsWidget";
import CommentsWidgetJLS from "../Widgets/CommentsWidgetJLS";

const { TabPane } = Tabs;

const testWidget=[
   
    
   
    
    // status_fastened_to_ground,
    // status_way_of_binding
    // preservation_adequacy_status
    // functionality_status
]

const SupplyAndDemandWidgets = [
    
    {
        id: 'DailyDemandPerHourGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/DailyDemandPerHourGraph", // relative to src
        layout: { i: 'DailyDemandPerHourGraph', x: 0, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
    },
    {
        id: 'MapWidget',
        visible: true,
        component: "components/Widgets/MapWidget", // relative to src
        layout: { i: 'MapWidget', x: 6, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
    },

    {
        id: 'NumberOfTypesOfStands', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'NumberOfTypesOfStands', x: 0, y: 3, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Udio identificiranih parkirališnih površina prema tipu stalka",
        answer_name:"bicycle_stand_type",
        survey_id:0,
    },

    {
        id: 'ParkingSpaceStandsByAccordanceToRulebook', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AccordanceToRulebookGraph",
        layout: { i: 'ParkingSpaceStandsByAccordanceToRulebook', x: 6, y: 3, w: 6, h: 4, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-space-stands-by-accordance-to-rulebook',	
        answer_title:'Udio identificiranih parkirališnih površina s obzirom na status usklađenosti s Pravilnikom',
    }, 

    
    {
        id: 'CoverTypePerParkingSpace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'CoverTypePerParkingSpace', x: 0, y: 7, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio identificiranih parkirališnih površina prema statusu natkrivenosti",
        answer_name:"cover_type",
        survey_id:0,
    },

    {
        id: 'BicycleStandsByType', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'BicycleStandsByType', x: 6, y: 7, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-vehicle-type',
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema tipu',
    },

    
    {
        id: 'ParkingSpacesByTypeGraph', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticStackedBarGraph",
        layout: { i: 'ParkingSpacesByTypeGraph', x: 0, y: 10, w: 12, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:['capacity_value_theoretical','capacity_value'],	
        answer_title:'Udio identificiranog kapaciteta prema tipu',
        stacked_horizontal_chart_y_axis:['Teorijski','Operativni'],
        offset_x:90,
        offset_y:-54,
        max_width:200,
    },
    
    {
        id: 'CoverTypePerSingularParkingSpot', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'CoverTypePerSingularParkingSpot', x: 0, y: 13, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-cover-type-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema statusu natkrivenosti',
    },
    {
        id: 'CoverTypePerCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'CoverTypePerCapacity', x: 6, y: 13, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-cover-type-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta prema statusu natkrivenosti',
    },

   
    {
        id: 'BicycleFastenedToGround', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleFastenedToGround', x: 0, y: 16, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-status-of-fastening-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema statusu učvršćivanja za tlo/objekt',
    },

    {
        id: 'BicycleFastenedToGroundCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleFastenedToGroundCapacity', x: 6, y: 16, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-status-of-fastening-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta prema statusu učvršćivanja za tlo/objekt',
    },
    {
        id: 'BicycleFastenedToGroundBySpace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleFastenedToGroundBySpace', x: 0, y: 19, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio identificiranih stalaka prema statusu učvršćivanja za tlo/objekt prema površini",
        answer_name:"status_fastened_to_ground",
    },
    {
        id: 'BicycleStandsBoundToPlaceBySpace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleStandsBoundToPlaceBySpace', x: 6, y:19, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio identificiranih stalaka prema statusu vezivanja bicikla za okvir prema površini",
        answer_name:"status_way_of_binding",
    },
    {
        id: 'BicycleStandsBoundToPlace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsBoundToPlace', x: 0, y: 22, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-bicycle-way-of-binding',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema statusu vezivanja bicikla za okvir',
    },
    {
        id: 'BicycleStandsBoundToPlaceCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsBoundToPlaceCapacity', x: 6, y: 22, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-bicycle-way-of-binding-by-type-and-spaces',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta prema statusu vezivanja bicikla za okvir',
    },
    

    {
        id: 'BicycleStandsInAccordanceWithRulebook', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsInAccordanceWithRulebook', x: 0, y: 25, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-recommendation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio stalaka usklađenih s Pravilnikom o biciklističkoj infrastrukturi',
    },

    {
        id: 'BicycleStandsInAccordanceWithRulebookCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsInAccordanceWithRulebookCapacity', x: 6, y: 25, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-recommendation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Udio identificiranog kapaciteta usklađenog s Pravilnikom o biciklističkoj infrastrukturi',
    },



    {
        id: 'FunctionalityStatusResident', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'FunctionalityStatusResident', x: 0, y: 28, w: 6, h: 3, isDraggable: true, isBounded: true },      
        analytic_url:'get-parking-stands-by-status-of-functionality-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Status adekvatnosti identificiranih stalaka s obzirom na funkcionalnost',
    },

    {
        id: 'FunctionalityStatusResidentCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'FunctionalityStatusResidentCapacity', x: 6, y: 28, w: 6, h: 3, isDraggable: true, isBounded: true },      
        analytic_url:'get-parking-capacity-by-status-of-functionality-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Status adekvatnosti identificiranog kapaciteta s obzirom na funkcionalnost',
    },

     
    {
        id: 'PreservationAdequacyResidentBySpace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'PreservationAdequacyResidentBySpace', x: 0, y: 31, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status adekvatnosti identificiranih stalaka s obzirom na stanje očuvanosti prema površini",
        answer_name:"preservation_adequacy_status",
    },

    {
        id: 'FunctionalityStatusResidentBySpace', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'FunctionalityStatusResidentBySpace', x: 6, y: 31, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status adekvatnosti identificiranih stalaka s obzirom na funkcionalnost prema površini",
        answer_name:"functionality_status",
    },
    {
        id: 'PreservationAdequacyResident', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'PreservationAdequacyResident', x: 0, y: 34, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-status-of-preservation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Status adekvatnosti identificiranih stalaka s obzirom na stanje očuvanosti',
    }, 

    {
        id: 'PreservationAdequacyResidentCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'PreservationAdequacyResidentCapacity', x: 6, y: 34, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-status-of-preservation-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'capacity_value',	
        answer_title:'Status adekvatnosti identificiranog kapaciteta stalaka s obzirom na stanje očuvanosti',
    }, 


    {
        id: 'BicycleStandsByPurpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i:'BicycleStandsByPurpose', x: 0, y: 37, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-stands-by-purpose-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:'stand_amount',	
        answer_title:'Udio identificiranih stalaka prema vrsti najbližeg objekta odnosno potencijalnoj svrsi korištenja',
    },

    {
        id: 'BicycleStandsByPurposeCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticStackedBarGraph",
        layout: { i:'BicycleStandsByPurposeCapacity', x: 6, y: 37, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-parking-capacity-by-purpose-and-vehicle-type',	
        survey_title_key:'legend_value',	
        survey_value_key:['capacity_value_theoretical','capacity_value'],	
        answer_title:'Udio identificiranih kapaciteta stalaka prema vrsti najbližeg objekta odnosno potencijalnoj svrsi korištenja',
        stacked_horizontal_chart_y_axis:['Teorijski','Operativni'],
        offset_x:90,
        offset_y:visualViewport.width>600&&-54||-27,
        max_width:200,
    },
   
    {
        id: 'DemandByPurposeCombinedGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticStackedBarGraph", // relative to src
        layout: { i: 'DemandByPurposeCombinedGraph', x: 0, y: 40, w: 12, h: 4, isDraggable: true, isBounded: true },
        analytic_url:'get-demand-by-purpose-combined',	
        survey_title_key:'svrha_parkiranja',	
        survey_value_key:['udio_potraznje','udio_potraznje_alt'],	
        answer_title:'Udio postojeće i alternativne(neadekvatan ili nepostojeći stalak) potražnje prema vrsti najbližeg objekta odnosno potencijalnoj svrsi korištenja',
        stacked_horizontal_chart_y_axis:['Postojeća','Alternativna'],
        offset_x:95,
        offset_y:-85,
        max_width:200,
    },

{
    id: 'DemandByStandTypeGraph',
    visible: true,
    component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
    layout: { i: 'DemandByStandTypeGraph', x: 0, y: 44, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    analytic_url:'get-demand-by-stand-type',	
    survey_title_key:'tip_stalka',	
    survey_value_key:'udio_potraznje',	
    answer_title:'Udio postojećih stalaka prema tipu pri unosu potražnje',
},
{
    id: 'ReasonsForNotUsingBicycleStandGraph',
    visible: true,
    component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
    layout: { i: 'ReasonsForNotUsingBicycleStandGraph', x: 6, y: 44, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    analytic_url:'get-reasons-for-not-using-bicycle-stand',	
    survey_title_key:'razlozi_ne_koristenja_stalka',	
    survey_value_key:'broj_odgovora',	
    answer_title:'Udio prijavljenih razloga ne korištenja postojećih stalaka pri unosu potražnje',
},

{
    id: 'ImportantImprovementElementSupply', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'ImportantImprovementElementSupply', x: 0, y: 48, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
    answer_title:"Udio najvažnijih elemenata unaprijeđenja pri unosu ponude",
    answer_name:"important_improvement_element",
    survey_id:0,  
},
{
    id: 'ImportantImprovementElementDemand', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'ImportantImprovementElementDemand', x: 6, y: 48, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
    answer_title:"Udio najvažnijih elemenata unaprijeđenja pri unosu potražnje",
    answer_name:"important_improvement_element_demand",
    survey_id:0,  
},
{/*
{
    id: 'DemandTypePurposeAndTimeOfStay',
    visible: true,
    component: "components/Widgets/WidgetGraphs/AnalyticGraphs/DemandTypePurposeAndTimeOfStay",
    layout: { i: 'DemandTypePurposeAndTimeOfStay', x: 0, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
},
*/},

{/*Potencijalno maknut jer ce se mozd amaknuti ta pitanja iz ankete
    {
        id: 'CoveredStandsByTypeGraph',
        visible: true,
        component:  "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'CoveredStandsByTypeGraph', x: 6, y: 3, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-covered-stands-by-type?',	survey_title_key:'tip_stalka',	survey_value_key:'udio_natkrivenih',	answer_title:'Udio natkrivenih stalaka po tipu',
    },
    {
        id: 'PreservedParkingSpacesByCoverageGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'PreservedParkingSpacesByCoverageGraph', x: 0, y: 12, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-preserved-parking-spaces-by-coverage',	survey_title_key:'natkrivenost',	survey_value_key:'udio_očuvanih_mjesta',	answer_title:'Udio očuvanih parkirnih mjesta po natkrivenosti',
    },
    {
        id: 'StandsByCoverageAndAltDemandGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'StandsByCoverageAndAltDemandGraph', x: 6, y: 15, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-stands-by-coverage-and-alt-demand',	survey_title_key:'natkrivenost',	survey_value_key:'udio_stalaka',	answer_title:'Udio stalka po natkrivenosti i potražnji',
    },
    {
        id: 'UnpreservedParkingSpacesByCoverageGraph', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'UnpreservedParkingSpacesByCoverageGraph', x: 0, y: 18, w: 12, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-unpreserved-parking-spaces-by-coverage',	survey_title_key:'natkrivenost',	survey_value_key:'udio_neočuvanih_mjesta',	answer_title:'Udio neočuvanih parkirnih mjesta po natkrivenosti',
    }, 
*/},
{/*Spojeni u jedan graf
    {
        id: 'AltDemandByPurposeGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph", // relative to src
        layout: { i: 'AltDemandByPurposeGraph', x: 0, y: 3, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-alt-demand-by-purpose',	survey_title_key:'svrha_parkiranja',	survey_value_key:'udio_potraznje',	answer_title:'Udio alternativne potražnje prema svrsi',
    },
    {
        id: 'DemandByPurposeGraph',
        visible: true,
        component:  "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'DemandByPurposeGraph', x: 0, y: 6, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-demand-by-purpose',	survey_title_key:'svrha_parkiranja',	survey_value_key:'udio_potraznje',	answer_title:'Udio potražnje prema svrsi',
    },
*/},
   
    
{/*  Pukne app
    {
        id: 'FunctionalParkingSpacesByCoverageGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'FunctionalParkingSpacesByCoverageGraph', x: 0, y: 9, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-functional-parking-spaces-by-coverage',	survey_title_key:'natkrivenost',	survey_value_key:'udio_funkcionalnih_mjesta',	answer_title:'Udio funkcionalnih parkirnih mjesta po natkrivenosti',
    },
    {
        id: 'NonFunctionalParkingSpacesByCoverageGraph',
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'NonFunctionalParkingSpacesByCoverageGraph', x: 6, y: 9, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-non-functional-parking-spaces-by-coverage',	survey_title_key:'natkrivenost',	survey_value_key:'udio_nefunkcionalnih_mjesta',	answer_title:'Udio nefunkcionalnih parkirnih mjesta po natkrivenosti',
    },
    {
        id: 'RecommendedStandsAndParkingSpaces', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/RecommendedStandsAndParkingSpaces",
        layout: { i: 'RecommendedStandsAndParkingSpaces', x: 0, y: 21, w: 6, h: 3, isDraggable: true, isBounded: true },
    }, 
*/},


    {/* Removed because it was giving wrong info
    {
        id: 'ReasonsForNotUsingScooterStandGraph', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/AnalyticGraphs/AnalyticDonutGraph",
        layout: { i: 'ReasonsForNotUsingScooterStandGraph', x: 0, y: 15, w: 6, h: 3, isDraggable: true, isBounded: true },
        analytic_url:'get-reasons-for-not-using-scooter-stand',	survey_title_key:'razlozi_ne_koristenja_stalka',	survey_value_key:'broj_odgovora',	answer_title:'Razlozi ne korištenja stalaka za romobile za potražnju',
    },
    */},
    
   
];
 
const ResidentWidgets = [
    // {
    //     id: 'CommentsWidget', 
    //     visible: true,
    //     component: "components/Widgets/CommentsWidget",
    //     layout: { i: 'CommentsWidget', x: 0, y: 54, w: 12, h: 4, isDraggable: true, isBounded: true },
    //     answer_title:"Komentari građani",
    //     answer_name:"user_comment",
    //     survey_id:6,
    // },  
    {
       id: 'JlsPickBigResident', 
       visible: true,
       component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticJLSBarGraph",
       layout: { i: 'JlsPickBigResident', x: 0, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
       answer_title:"Prostorni raspored prikupljenog uzorka",
       answer_name:"jls_pick",
       survey_id:6,
   }, 
   {
       id: 'ageBigResident', 
       visible: true,
       component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticAgeDonutGraph",
       layout: { i: 'ageBigResident', x: 6, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
       answer_title:"Uzorak prema dobnim skupinama",
       answer_name:"age",
       survey_id:6,
   },
   {
    id: 'WorkActivityBigResident', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'WorkActivityBigResident', x: 0, y: 3, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Uzorak prema radnoj aktivnosti ispitanika",
    answer_name:"work_activity",
    survey_id:6,
}, 
{/* Moraju se promjeniti pa su izbaceni
    {
    id: 'DriverLicenseBigResident', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'DriverLicenseBigResident', x: 6, y: 3, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Udio prijavljenog posjedovanja vozačke dozvole",
    answer_name:"driver_license",
    survey_id:6,
},
{
    id: 'DriverAvailableCar', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'DriverAvailableCar', x: 0, y: 6, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Udio odgovora gdje je auto dostupan u funkciji vozača",
    answer_name:"driver_available_car",
    survey_id:6,
}, 
{
    id: 'PassengerAvailableCar', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'PassengerAvailableCar', x: 6, y: 6, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Udio odgovora gdje je auto dostupan u fuknciji putnika",
    answer_name:"passenger_available_car",
    survey_id:6,
},

*/ },

{
    id: 'AvailableBicycle', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'AvailableBicycle', x: 6, y: 3, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Status ispitanika s obzirom na dostupnost bicikla za svakodnevno korištenje",
    answer_name:"available_bicycle",
    survey_id:6,
}, 
{
    id: 'UnavailableBicycleReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'UnavailableBicycleReason', x: 0, y: 6, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Najčešći razlozi nedostupnosti bicikla za svakodnevno korištenje",
    answer_name:"unavailable_bicycle_reason",
    survey_id:6,
},
{/* Nije javno dostupno
    {
    id: 'AvailableBicycleAge', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'AvailableBicycleAge', x: 0, y: 12, w: 6, h: 3, isDraggable: true, isBounded: true },
    answer_title:"Struktura starosti ispitanicima dostupnih bicikala",
    answer_name:"available_bicycle_age",
    survey_id:6,
}, 
*/},

{
    id: 'BicycleUsagePurposeYesOrNo', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/BicycleUsagePurpose",
    layout: { i: 'BicycleUsagePurposeYesOrNo', x: 0, y: 9, w: 6, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Struktura aktivnosti korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_purpose_yes_or_no",
    survey_id:6,
},   
{
    id: 'BicycleUsagePurposeOnlyYes', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/BicycleUsagePurpose",
    layout: { i: 'BicycleUsagePurposeOnlyYes', x: 6, y: 9, w: 6, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Najčešća svrha korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_purpose_only_yes",
    survey_id:6,
},   
{
    id: 'BicycleUsageFrequency', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageFrequency', x: 0, y: 12, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
    answer_title:"Učestalost korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_frequency",
    survey_id:6,
}, 
{
    id: 'BicycleUsageFrequencyByPurpose-purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageFrequencyByPurpose-purpose', x: 0, y: 15, w: 12, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Učestalost korištenja bicikla prema svrsi putovanja",  
    analytic_url:'get-bicycle-usage-frequency-by-purpose',  
    filter_key:'purpose',
    mapped_key:'frequency',    
}, 

{
    id: 'BicycleUsageFrequencyByPurpose-frequency', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageFrequencyByPurpose-frequency', x: 0, y: 19, w: 12, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Učestalost korištenja bicikla prema svrsi putovanja", 
    analytic_url:'get-bicycle-usage-frequency-by-purpose',
    filter_key:'frequency',
    mapped_key:'purpose',
    filter_elements:'bicycle_frequency'
}, 

{
    id: 'BicycleUsageReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageReason', x: 0, y: 23, w: 6, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Najčešći razlozi motivacije korištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_reason",
    survey_id:6,
},    


{
    id: 'BicycleUsageChallenge', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageChallenge', x: 6, y: 23, w: 6, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Najčešći izazovi pri korištenju bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_usage_challenge",
    survey_id:6,
}, 
        
{
    id: 'BicycleUsageParkingPurpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingPurpose', x: 0, y:27, w: 6, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Najčešći načini odlaganja (parkiranja) bicikla",
    answer_name:"bicycle_usage_parking_purpose",
    survey_id:6,
}, 
{
    id: 'BicycleUsageParkingPurposeByPurpose-purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingPurposeByPurpose-purpose', x: 0, y:31, w: 12, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Najčešći načini odlaganja (parkiranja) bicikla po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-purpose-by-purpose',
    mapped_key:'parking_purpose',
    filter_key:'purpose',
}, 
{
    id: 'BicycleUsageParkingPurposeByPurpose-parking_purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingPurposeByPurpose-parking_purpose', x: 0, y:31, w: 12, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Najčešći načini odlaganja (parkiranja) bicikla po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-purpose-by-purpose',
    mapped_key:'purpose',
    filter_key:'parking_purpose',
    filter_elements:'bicycle_parking_purpose'
}, 
{
    id: 'BicycleUsageParkingStandType', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingStandType', x: 0, y: 35, w: 6, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Najčešće dostupan tip stalaka za odlaganje (parkiranje) bicikala",
    answer_name:"bicycle_usage_parking_stand_type",
    survey_id:6,
},    
{
    id: 'BicycleUsageParkingStandTypeByPurpose-purpose', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingStandTypeByPurpose-purpose', x: 0, y: 39, w: 12, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Najčešće dostupan tip stalaka za odlaganje (parkiranje) bicikala po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-stand-type-by-purpose',
    mapped_key:'parking_stand_type',
    filter_key:'purpose',
},       
{
    id: 'BicycleUsageParkingStandTypeByPurpose-stand_type', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
    layout: { i: 'BicycleUsageParkingStandTypeByPurpose-stand_type', x: 0, y: 44, w: 12, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Najčešće dostupan tip stalaka za odlaganje (parkiranje) bicikala po pojedinim svrhama",
    analytic_url:'get-bicycle-usage-parking-stand-type-by-purpose',
    mapped_key:'purpose',
    filter_key:'parking_stand_type',
    filter_elements:'bicycle_stand_type'
}, 
{
    id: 'BicycleUsageParkingInadequacyReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingInadequacyReason', x: 0, y: 48, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Najčešći elementi neadekvatnosti dostupnih stalaka za odlaganje bicikala",
    answer_name:"bicycle_usage_parking_inadequacy_reason",
    survey_id:6,
},         
{
    id: 'BicycleUsageParkingOptimalTypeOfStand', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleUsageParkingOptimalTypeOfStand', x: 6, y: 48, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Optimalan tip stalka prema izboru biciklista",
    answer_name:"bicycle_usage_parking_optimal_type_of_stand",
    survey_id:6,
},          
     
 
{
    id: 'BicycleNonUsageReason', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'BicycleNonUsageReason', x:0, y: 52, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Najčešći razlozi nekorištenja bicikla kao prijevoznog sredstva",
    answer_name:"bicycle_non_usage_reason",
    survey_id:6,
},          
  
{
    id: 'ReasonsMotivationToUseBicycle', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
    layout: { i: 'RulebookKnowledgeBigJls', x: 6, y: 52, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
    answer_title:"Najvažniji razlozi motivacije korištenja bicikla/sustava javnih bicikala ",
    answer_name:"reasons_motivation_to_use_bicycle",
    survey_id:6,
},  
      {/* Nije javno dostupno
    {
    id: 'RatingAvailableBicycle', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
    layout: { i: 'RatingAvailableBicycle', x: 0, y: 42, w: 12, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Udio odgovora prema ocjeni dostupnog bicikla građanima",
    answer_name:"rating_available_bicycle",
    survey_id:6,
}, 
    */},
    /*
    {
        id: 'ScooterUsagePurpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsagePurpose', x: 0, y:35, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Struktura aktivnosti korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_purpose",
        survey_id:6,
    },    */

    {
        id: 'ScooterUsagePurposeYesOrNo', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/ScooterUsagePurpose",
        layout: { i: 'ScooterUsagePurposeYesOrNo', x: 0, y: 56, w: 12, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Struktura aktivnosti korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_purpose_yes_or_no",
    },   
    {
        id: 'ScooterUsagePurposeOnlyYes', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/ScooterUsagePurpose",
        layout: { i: 'ScooterUsagePurposeOnlyYes', x: 6, y: 60, w: 12, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Najčešća svrha korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_purpose_only_yes",
    },   

    {
        id: 'ScooterUsageFrequency', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageFrequency', x: 0, y:64, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Učestalost korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_frequency",
        survey_id:6,
    }, 
    {
        id: 'ScooterUsageFrequency-purpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageFrequency-purpose', x: 0, y:68, w: 12, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Učestalost korištenja romobila prema svrsi putovanja",
        analytic_url:'get-scooter-usage-frequency-by-purpose',
        mapped_key:'frequency',
        filter_key:'purpose',
    }, 
    {
        id: 'ScooterUsageFrequency-frequency', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageFrequency-frequency', x: 0, y:72, w: 12, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Učestalost korištenja romobila prema svrsi putovanja",
        analytic_url:'get-scooter-usage-frequency-by-purpose',
        mapped_key:'purpose',
        filter_key:'frequency',
        filter_elements:'scooter_frequency'
    }, 
    {
        id: 'ScooterUsageReason', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageReason', x: 0, y: 76, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Najčešći razlozi motivacije korištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_reason",
        survey_id:6,
    }, 
    {
        id: 'ScooterUsageChallenge', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageChallenge', x: 6, y: 76, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Najčešći izazovi pri korištenju romobila kao prijevoznog sredstva",
        answer_name:"scooter_usage_challenge",
        survey_id:6,
    },  
    {
        id: 'ScooterUsageParkingTypeReplacement', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageParkingTypeReplacement', x: 0, y: 80, w: 6, h: 4, isDraggable: true, isBounded: true },
        //ovo nije dobro
        answer_title:"Najčešći načini odlaganja (parkiranja) romobila",
        answer_name:"scooter_usage_parking_type_replacement",
        survey_id:6,
    }, 
    
    {
        id: 'ScooterUsageParkingTypeReplacement-purpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageParkingTypeReplacement-purpose', x: 0, y: 84, w: 12, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Najčešći načini odlaganja (parkiranja) romobila po pojedinim svrhama",
        analytic_url:'get-scooter-usage-parking-purpose-by-purpose',
        mapped_key:'parking_purpose',
        filter_key:'purpose',
    },  
    {
        id: 'ScooterUsageParkingTypeReplacement-parking_purpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'ScooterUsageParkingTypeReplacement-stand_type', x: 0, y: 88, w: 12, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Najčešći načini odlaganja (parkiranja) romobila po pojedinim svrhama",
        analytic_url:'get-scooter-usage-parking-purpose-by-purpose',
        mapped_key:'purpose',
        filter_key:'parking_purpose',
        filter_elements:'scooter_parking_purpose'
    },  

    {
        id: 'ScooterUsageParkingInadequacyReason', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ScooterUsageParkingInadequacyReason', x: 0, y: 92, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Najčešći elementi neadekvatnosti dostupnih stalaka za odlaganje romobila",
        answer_name:"scooter_usage_parking_inadequacy_reason",
        survey_id:6,
    },     
    {
        id: 'BicycleUsageParkingTypeReplacement', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleUsageParkingTypeReplacement', x: 6, y: 92, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Optimalan tip stalka za bickle kao kvalitetna alternativa stalku za romobile",
        answer_name:"bicycle_usage_parking_type_replacement",
        survey_id:6,
    },     
{/*  trenutno su netocni rezultati jer je dohvat podataka netocan
    {
        id: 'BicycleUsageParkingTypeReplacement-purpose', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'BicycleUsageParkingTypeReplacement-purpose', x: 6, y: 30, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Optimalan tip stalka za bickle kao kvalitetna alternativa stalku za romobile",
        analytic_url:'get-scooter-usage-parking-stand-type-by-purpose',
        mapped_key:'parking_stand_type',
        filter_key:'purpose',
    },

    {
        id: 'BicycleUsageParkingTypeReplacement-stand_type', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/ResidentWidgetGraphs/AnalyticDonutGraphWithFilter",
        layout: { i: 'BicycleUsageParkingTypeReplacement-stand_type', x: 6, y: 30, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Optimalan tip stalka za bickle kao kvalitetna alternativa stalku za romobile",
        analytic_url:'get-scooter-usage-parking-stand-type-by-purpose',
        mapped_key:'purpose',
        filter_key:'parking_stand_type',
        filter_elements:'scooter_stand_type'
    },
*/},
    {
        id: 'ScooterNonUsageReason', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'RulebookKnowledgeBigJls', x: 0, y: 96, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
        answer_title:"Najčešći razlozi nekorištenja romobila kao prijevoznog sredstva",
        answer_name:"scooter_non_usage_reason",
        survey_id:6,
    },     







{
    id: 'RatingJls', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
    layout: { i: 'RatingJls', x: 0, y: 33, w:12, h: 8, isDraggable: true, isBounded: true },
    answer_title:"Struktura ocjena elemenata postojećeg stanja",
    answer_name:"rating_jls",
    survey_id:6,
    offset_x:visualViewport.width>600&&350||295,
    offset_y:-60,
    max_width:visualViewport.width>600&&600||330,
}, 
{
    id: 'RateAgreeingWithClaim', 
    visible: true,
    component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
    layout: { i: 'RateAgreeingWithClaim', x: 0, y: 41, w: 12, h: 4, isDraggable: true, isBounded: true },
    answer_title:"Struktura stavova",
    answer_name:"rate_agreeing_with_claim",
    survey_id:6,
    offset_x:visualViewport.width>600&&950||220,
    offset_y:visualViewport.width>600&&-55||-51,
    max_width:visualViewport.width>600&&1100||300,
},

];

const JlsWidgets = [
     {
        id: 'JlsPickBigJls', 
        visible: true,
        component: "components/Widgets/SurveyAnsweredWidgetJLS",
        layout: { i: 'JlsPickBigJls', x: 0, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Gradovi i općine čiji su predstavnici ispunili web upitnik za jedinice lokalne samouprave",
        answer_name:"jls_pick",
        survey_id:1,
    }, 
    {
        id: 'RulebookKnowledgeBigJls', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'RulebookKnowledgeBigJls', x: 6, y: 0, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na poznavanje sadržaja Pravilnika o biciklističkoj infrastrukturi (NN28/2016)",
        answer_name:"rulebook_knowledge",
        survey_id:1,
    },
    {
        id: 'RulebookDeadlineKnowledge', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'RulebookDeadlineKnowledge', x: 0, y:3, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na upoznatost s vremenskim rokovima za usklađivanje postojeće infrastrukture definirane Pravilnikom o biciklističkoj infrastrukturi (NN28/2016)",
        answer_name:"rulebook_deadline_knowledge",
        survey_id:1,
    }, 
    {
        id: 'RulebookImplementedElements', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'RulebookImplementedElements', x: 6, y:3, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Udio elemenata postojećeg prometnog sustava koje su (sukladno navodima u web upitniku) JLS-ovi uskladili s Pravilnikom o biciklističkoj infrastrukturi u Pravilnikom definiranim rokovima",
        answer_name:"rulebook_implemented_elements",
        survey_id:1,
    }, 

    {
        id: 'ElaborationCreationStatus', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ElaborationCreationStatus', x: 0, y:6, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu izrade prometnog elaborata u funkciji analize, pripreme i provedbe unaprjeđenja postojeće biciklističke infrastrukture",
        answer_name:"elaboration_creation_status",
        survey_id:1,
    }, 
    {
        id: 'DatabaseOfBicycleInfrastructureSpatialCoverage', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureSpatialCoverage', x: 6, y:6, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu vođenja evidencije prostorne pokrivenosti biciklističkom infrastrukturom",
        answer_name:"database_of_bicycle_infrastructure_spatial_coverage",
        survey_id:1,
    }, 

    {
        id: 'DatabaseOfBicycleInfrastructureSpatialCoverageStorageType', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureSpatialCoverageStorageType', x: 0, y:9, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći način kojim JLS-ovi vode evidenciju prostorne pokrivenosti biciklistčkom infrastrukturom",
        answer_name:"database_of_bicycle_infrastructure_spatial_coverage_storage_type",
        survey_id:1,
    }, 
    {
        id: 'DatabaseOfBicycleInfrastructureSpatialCoverageAvailability', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureSpatialCoverageAvailability', x: 6, y:9, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Status javne dostupnosti evidencije prostorne pokrivenosti biciklističkom infrastrukturom koju vode JLS-ovi",
        answer_name:"database_of_bicycle_infrastructure_spatial_coverage_availability",
        survey_id:1,
    }, 

    {
        id: 'DatabaseOfBicycleInfrastructureCapacity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureCapacity', x: 0, y:12, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu vođenja evidencije prostorne pokrivenosti parkirališnih kapaciteta za bicikle/romobile",
        answer_name:"database_of_bicycle_infrastructure_capacity",
        survey_id:1,
    }, 
    {
        id: 'DatabaseOfBicycleInfrastructureCapacityStorageType', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureCapacityStorageType', x: 6, y:12, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Najčešći način kojim JLS-ovi vode evidenciju prostorne pokrivenosti parkirališnih kapaciteta za bicikle/romobile",
        answer_name:"database_of_bicycle_infrastructure_capacity_storage_type",
        survey_id:1,
    }, 

    {
        id: 'DatabaseOfBicycleInfrastructureCapacityAvailability', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'DatabaseOfBicycleInfrastructureCapacityAvailability', x: 0, y:15, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Status javne dostupnosti evidencije prostorne pokrivenosti parkirališnih kapaciteta za bicikle/romobile",
        answer_name:"database_of_bicycle_infrastructure_capacity_availability",
        survey_id:1,
    }, 
    {
        id: 'ImplementedBicycleTracks', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ImplementedBicycleTracks', x: 6, y:15, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Najčešći tip implementiranih biciklističkih prometnica prema evidenciji JLS-ova",
        answer_name:"implemented_bicycle_tracks",
        survey_id:1,
    }, 

    {
        id: 'BicycleSystemUpgradeDifficulties', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleSystemUpgradeDifficulties', x: 0, y:18, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
        answer_title:"Udio najčešćih izazova pri provedbi unaprjeđenja/razvoja biciklističkog sustava",
        answer_name:"bicycle_system_upgrade_difficulties",
        survey_id:1,
    }, 
    {
        id: 'BicycleInfrastructureImportance', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BicycleInfrastructureImportance', x: 6, y:18, w: 6, h: visualViewport.width>600&&4||4, isDraggable: true, isBounded: true },
        answer_title:"Razina važnosti implementacije biciklističke infrastrukture u funkciji razvoja održive mobilnosti ",
        answer_name:"bicycle_infrastructure_importance",
        survey_id:1,
    },
    {
        id: 'OptimalCapacityImplementationImportance', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'OptimalCapacityImplementationImportance', x: 0, y:21, w: 6, h: visualViewport.width>600&&3||4, isDraggable: true, isBounded: true },
        answer_title:"Razina važnosti implementacije optimalnog broja parkirališnih kapaciteta za bicikle u funkciji razvoja kvalitetnog biciklističkog sustava",
        answer_name:"optimal_capacity_implementation_importance",
        survey_id:1,
    }, 
    {
        id: 'ParkingCapacityAdditionLastYear', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ParkingCapacityAdditionLastYear', x: 6, y:21, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova prema statusu implementacije novih parkirališnih kapaciteta za bicikle tijekom 2022. godine",
        answer_name:"parking_capacity_addition_last_year",
        survey_id:1,
    },

    {
        id: 'BiggestChallengeInImplementationOfOptimalParkingSystem', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'BiggestChallengeInImplementationOfOptimalParkingSystem', x: 0, y:24, w: 6, h: visualViewport.width>600&&4||5, isDraggable: true, isBounded: true },
        answer_title:"Udio najvećih izazova pri dostizanju optimalanog razvoja sustava parkirališne ponude za bicikle i romobile",
        answer_name:"biggest_challenge_in_implementation_of_optimal_parking_system",
        survey_id:1,
    }, 
    {
        id: 'ExistanceOfParkingCapacityForRomobile', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'ExistanceOfParkingCapacityForRomobile', x: 6, y:24, w: 6, h: 4, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na dostupnost parkirališnih kapaciteta za romobile",
        answer_name:"existance_of_parking_capacity_for_romobile",
        survey_id:1,
    },

    {
        id: 'PublicBicycleSystem', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'PublicBicycleSystem', x: 0, y:27, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Status JLS-ova s obzirom na dostupnost sustava javnih bicikala",
        answer_name:"public_bicycle_system",
        survey_id:1,
    }, 
    {
        id: 'StrategicImplementationPlanAvailability', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticDonutGraph",
        layout: { i: 'StrategicImplementationPlanAvailability', x: 6, y:27, w: 6, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Udio JLS-ova s obzirom status posjedovanja strateško-implementativnog plana podizanja prostorne pokrivenosti, kvalitete i kapaciteta parkirališne ponude za bicikle i romobile",
        answer_name:"strategic_implementation_plan_availability",
        survey_id:1,
    },                                                                                                                                                                                                                                                 
   
    {
        id: 'BicycleInfrastructureComplexity', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'RatingAvailableBicycle', x: 0, y: 30, w: 12, h: 8, isDraggable: true, isBounded: true },
        answer_title:"Omjer ocjena razine kompleksnosti implementacije navedenih elemenata(stavovi predstavnika JLS-ova)",
        answer_name:"bicycle_infrastructure_complexity",
        survey_id:1,
        offset_x:visualViewport.width>600&&450||295,
        offset_y:-38,
        max_width:visualViewport.width>600&&550||330,
    }, 
    {
        id: 'ParkingOfferRating', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'RatingAvailableBicycle', x: 0, y: 38, w: 12, h: 5, isDraggable: true, isBounded: true },
        answer_title:"Omjer ocjena postojeće biciklističke parkirališne ponude navedenih elemenata(stavovi predstavnika JLS-ova)",
        answer_name:"parking_offer_rating",
        survey_id:1,
        offset_x:visualViewport.width>600&&530||280,
        offset_y:visualViewport.width>600&&-48||-42,
        max_width:visualViewport.width>600&&650||400,
    }, 
    {
        id: 'ParkingOfferInAccordanceToBuildingTypeRating', 
        visible: true,
        component: "components/Widgets/WidgetGraphs/StatisticGraphs/StatisticBarGraph",
        layout: { i: 'RatingAvailableBicycle', x: 0, y: 43, w: 12, h: 5, isDraggable: true, isBounded: true },
        answer_title:"Omjer ocjena usklađenosti postojeće parkirališne ponude s pravilnikom(stavovi predstavnika JLS-ova)",
        answer_name:"parking_offer_in_accordance_to_building_type_rating",
        survey_id:1,
        offset_x:240,
        offset_y:-32,
        max_width:400,
    }, 
    {/* postavljen je temp fix pa je zakomentirano
    {
        id: 'CommentsWidgetJLS', 
        visible: true,
        component: "components/Widgets/CommentsWidgetJLS",
        layout: { i: 'CommentsWidgetJLS', x: 0, y:27, w: 12, h: 3, isDraggable: true, isBounded: true },
        answer_title:"Komentari JLS",
        answer_name:"jls_comment",
        survey_id:6,
    }, 
    */}
];






const AnalyticsDashboard = ({show, onClose, ...props}) => {

    const [search_params, setSearchParams] = useState(null)
    

    return (
        
        <Modal
            className="analytics-dashboard"
            visible={show}
            onCancel={onClose}
            footer={null}
            title={visualViewport.width>600&&"Analitika – alat za učinkovitije upravljanje biciklističkom parkirališnom ponudom i potražnjom"||"Analitika" }
        >
        <Tabs defaultActiveKey="1">
        <TabPane tab={visualViewport.width>600&&"Analitika – identificirana ponuda i potražnja" ||"Ponuda i potražnja"} key="1">
            <div className="analytics__search">
                <MunicipalitySearchAnalytics />
                <StandType />
            </div>
       
            <Dashboard widgets={SupplyAndDemandWidgets} search_params={search_params} {...props} />
        </TabPane>

        
        <TabPane tab={visualViewport.width>600&&"Analitika – upitnik za stanovnike"||"Upitnik za stanovnike"} key="2">
        <div className="analytics__search">
                <MunicipalitySearchAnalytics />
                <StandType />
            </div>

            <Dashboard widgets={ResidentWidgets} search_params={search_params} {...props} />
            <CommentsWidget />
        </TabPane>

        <TabPane tab={visualViewport.width>600&&"Analitika – upitnik za predstavnike JLS-ova"||"Upitnik za predstavnike JLS-ovaㅤㅤ"} key="3">
            <div className="analytics__search">
                <MunicipalitySearchAnalytics />
                <StandType />
            </div>

            <Dashboard widgets={JlsWidgets} search_params={search_params} {...props} />
            <CommentsWidgetJLS />
        </TabPane>
        </Tabs>
        </Modal>	
        
    )
}

export default AnalyticsDashboard;